import React, { useState,useRef, useEffect } from 'react';
import {Link} from 'react-router-dom' 
import N3rveLogo from './../../images/N3rveLogo.png'
import './ForgotPassword.css'
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Trans, useTranslation} from 'react-i18next'
import i18next from "i18next"

function PassReset() {
  const [email, onChangeEmail] = useState('')
  const [password, onChangePassword] = useState('');
  const [PassReseterror,setPassResetError] = useState(false)
  const [buttonClick,setButtonClick] = useState(false)
  const navigate = useNavigate()
  const {t, i18n } = useTranslation();
  

  const [dimensions, setDimensions] = useState({ 
    height: window.innerHeight,
    width: window.innerWidth
  })

  const handleResize = () => {
    // console.log(window.innerWidth)
    setDimensions({
    width: window.innerWidth,
    height: window.innerHeight,
    });
  }

  
  useEffect(()=>{
    window.addEventListener("resize", handleResize, false);
  },[])


  const HandleClick =()=>{
    HandlePassReset()
    setButtonClick(!buttonClick)
  }

  const HandlePassReset = () => {
    axios({
      method:'post',
      url:"https://n3rve.fly.dev/auth/forgot",
      data:{
        email:email,
        // domain:'http://localhost:3000'
        domain:'https://n3rve-b4b3b625d069.herokuapp.com'
      }
  }).then(res=>{
    console.log(res)
  }).catch((e)=>{
    console.log(e)
  })

}

  return (
    <div style={{width:'100vw'}}>

    {/* ******************************************** */}


    {/* DESKTOP VIEW */}

    {
    dimensions.width >= 1024 &&
    <div className="PassResetContainer">

      <div className='PassResetContainerLeft' >
          <Link to="/"  style={{ textDecoration: 'none' }}>
            <img src={N3rveLogo} alt="Nerve Logo" className='N3rveLogo'/>
            </Link>

            { !buttonClick &&
                <div style={{display:'flex',flexDirection:'column',marginLeft:'11.25em'}}>
                    <div className='WelcomeBackTxt'>
                    <Trans i18nKey="Forgotpasswordh1" components={{1:<br/>}} >
                    Forgot <br/> Password?
                     </Trans></div>
                    <div className='PleaseEnterTxt'>
                    <Trans i18nKey="Enteryournerveemail" components={{1:<br/>}} >
                    Enter your N3RVE email address and we’ll send<br/> you a link to reset your password.
                     </Trans></div>

                    <div className='PassResetHeader'>{t('Email')}</div>
                    <input
                    value={email}
                    onChange={e => onChangeEmail(e.target.value)} 
                    placeholder='Enter Email'
                    className='PassResetInput'
                    />

            
                    <button onClick={()=>HandleClick()} className='PassResetBtn' style={{cursor:'pointer'}}>{t('Sendresetlink')}<div className="HoverOverlay" /></button>
                    <span className='DontHaveAccTxt'>{t('Ifyoustillneedhelp')}<Link to="/Signup"><span className='DontHaveAccTxt' style={{textDecoration:'underline'}}>{t('Contactsup')}</span></Link></span>
                </div>
            }

            { buttonClick &&
                <div style={{display:'flex',flexDirection:'column',marginLeft:'11.25em'}}>
                    <div className='WelcomeBackTxt'>{t('Checkyouremail')}</div>
                    <span className='PleaseEnterTxt'>{t('Wejustsentapassword')}<br/>
                    <span style={{color:'#ffffff'}}>{email}</span> <br/>
                    <br/>
                    <Trans i18nKey="Clickthelinkintheemail" components={{1:<br/>}} >
                    Click on the link in the email and you'll be 
                     brought <br/> back here to reset your password.
                     </Trans>
                   </span>
            
                    <button className='PassResetBtn' style={{cursor:'pointer'}} onClick={()=>navigate("/Login")}>{t('Back')}<div className="HoverOverlay" /></button>
                   
                </div>
            }
      </div>

      <div className='PassResetContainerRight' style={{backgroundImage:`url("https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/eyufx2dvaxabuykbx9sl")`,height:dimensions.height,width:'50%'}}/>
        

      </div>
    }



    {/* /****************************************************************************** */}

    {/* /** TABLET VIEW */}
    {
    dimensions.width >= 768 && dimensions.width <1024 && 
    <div className="PassResetContainer" style={{justifyContent:'space-between'}}>

      <div className='PassResetContainerLeft' >
          <Link to="/"  style={{ textDecoration: 'none' }}>
            <img src={N3rveLogo} alt="Nerve Logo" className='N3rveLogo'/>
            </Link>

            { !buttonClick &&
                <div style={{display:'flex',flexDirection:'column',marginLeft:'2.25em'}}>
                    <div className='WelcomeBackTxt'>
                    <Trans i18nKey="Forgotpasswordh1" components={{1:<br/>}} >
                    Forgot <br/> Password?
                     </Trans></div>
                    <div className='PleaseEnterTxt'>
                    <Trans i18nKey="Enteryournerveemail" components={{1:<br/>}} >
                    Enter your N3RVE email address and we’ll send<br/> you a link to reset your password.
                     </Trans></div>

                    <div className='PassResetHeader'>{t('Email')}</div>
                    <input
                    value={email}
                    onChange={e => onChangeEmail(e.target.value)} 
                    placeholder='Enter Email'
                    className='PassResetInput'
                    />

            
                    <button onClick={()=>HandleClick()} className='PassResetBtn' style={{cursor:'pointer'}}>{t('Sendresetlink')}</button>
                    <span className='DontHaveAccTxt'>{t('Ifyoustillneedhelp')}<Link to="/Signup"><span className='DontHaveAccTxt' style={{textDecoration:'underline'}}>{t('Contactsup')}</span></Link></span>
                </div>
            }

            { buttonClick &&
                <div style={{display:'flex',flexDirection:'column',marginLeft:'2.25em'}}>
                    <div className='WelcomeBackTxt'>{t('Checkyouremail')}</div>
                    <span className='PleaseEnterTxt'>{t('Wejustsentapassword')}<br/>
                    <span style={{color:'#ffffff'}}>{email}</span> <br/>
                    <br/>
                    <Trans i18nKey="Clickthelinkintheemail" components={{1:<br/>}} >
                    Click on the link in the email and you'll be 
                     brought <br/> back here to reset your password.
                     </Trans>
                   </span>
            
                    <button className='PassResetBtn' style={{cursor:'pointer'}} onClick={()=>navigate("/Login")}>{t('Back')}</button>
                   
                </div>
            }
      </div>

      <div className='PassResetContainerRight' style={{backgroundImage:`url("https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/eyufx2dvaxabuykbx9sl")`,height:dimensions.height,width:'30%'}}/>
        

      </div>
    }



    {/* /****************************************************************************** */}

    {/* /** MOBILE VIEW */}
    {
    dimensions.width < 768 && 
    <div className="PassResetContainer" style={{height:'100vh',overflowY:'scroll'}}>

      <div className='PassResetContainerLeft' style={{width:'100%'}}>
          <Link to="/"  style={{ textDecoration: 'none' }}>
            <img src={N3rveLogo} alt="Nerve Logo" className='N3rveLogo'/>
            </Link>

            { !buttonClick &&
                <div style={{display:'flex',flexDirection:'column',marginLeft:'2.25em'}}>
                    <div className='WelcomeBackTxt'>
                    <Trans i18nKey="Forgotpasswordh1" components={{1:<br/>}} >
                    Forgot <br/> Password?
                     </Trans></div>
                    <div className='PleaseEnterTxt'>
                    <Trans i18nKey="Enteryournerveemail" components={{1:<br/>}} >
                    Enter your N3RVE email address and we’ll send<br/> you a link to reset your password.
                     </Trans></div>

                    <div className='PassResetHeader'>{t('Email')}</div>
                    <input
                    value={email}
                    onChange={e => onChangeEmail(e.target.value)} 
                    placeholder='Enter Email'
                    className='PassResetInput'
                    />

            
                    <button onClick={()=>HandleClick()} className='PassResetBtn' style={{cursor:'pointer'}}>{t('Sendresetlink')}</button>
                    <span className='DontHaveAccTxt'>{t('Ifyoustillneedhelp')}<Link to="/Signup"><span className='DontHaveAccTxt' style={{textDecoration:'underline'}}>{t('Contactsup')}</span></Link></span>
                </div>
            }

            { buttonClick &&
                <div style={{display:'flex',flexDirection:'column',marginLeft:'2.25em'}}>
                    <div className='WelcomeBackTxt'>{t('Checkyouremail')}</div>
                    <span className='PleaseEnterTxt'>{t('Wejustsentapassword')}<br/>
                    <span style={{color:'#ffffff'}}>{email}</span> <br/>
                    <br/>
                    <Trans i18nKey="Clickthelinkintheemail" components={{1:<br/>}} >
                    Click on the link in the email and you'll be 
                     brought <br/> back here to reset your password.
                     </Trans>
                   </span>
            
                    <button className='PassResetBtn' style={{cursor:'pointer'}} onClick={()=>navigate("/Login")}>{t('Back')}</button>
                   
                </div>
            }
      </div>

     
        

      </div>
    }


    </div>
  );
}

export default PassReset;